<script>
export default {
  name: "SelectNotationDropdown",
  computed: {
    notations: () => Notations.all,
  },
  methods: {
    notationName(notationName = "") {
      let nName = notationName;

      nName = nName.replace("Scientific", "Научная");
      nName = nName.replace("Engineering", "Инженерная");
      nName = nName.replace("Letters", "Буквенная");
      nName = nName.replace("Standard", "Стандартная");
      nName = nName.replace("Emoji", "Эмодзи");
      nName = nName.replace("Mixed scientific", "Смешанная научная");
      nName = nName.replace("Mixed engineering", "Смешанная инженерная");
      nName = nName.replace("Logarithm", "Логарифмическая");
      nName = nName.replace("Brackets", "Скобки");
      nName = nName.replace("Infinity", "Бесконечность");
      nName = nName.replace("Roman", "Римская");
      nName = nName.replace("Dots", "Точки");
      nName = nName.replace("Zalgo", "Залго");
      nName = nName.replace("Hex", "Шестнадцетеричная");
      nName = nName.replace("Imperial", "Имперская");
      nName = nName.replace("Clock", "Часы");
      nName = nName.replace("Prime", "Прайм");
      nName = nName.replace("Bar", "Полоса");
      nName = nName.replace("Shi", "Ши");
      nName = nName.replace("Blind", "Слепая");
      nName = nName.replace("Blobs", "Блобы");
      nName = nName.replace("ALL", "ВСЕ");

      return nName;
    },
  },
};
</script>

<template>
  <div class="l-select-notation">
    <div class="l-select-notation__inner">
      <div
        v-for="notation in notations"
        :key="notation.name"
        class="o-primary-btn l-select-notation__item c-select-notation__item"
        @click="notation.setAsCurrent()"
      >
        {{ notationName(notation.name) }}
      </div>
    </div>
  </div>
</template>
